<div class="d-flex flex-row align-items-center">
  <div class="flex-row step-status-inactive" [ngClass]="{'step-status':step >= 0   }">
    <p class="fs-16px " [ngClass]="{'step-status-check':step > 0 }">{{'header.step1'| translate}} <img alt=""
        src="../../../../assets/images/formCorrect.svg" class="TitleFormAlert-icon" *ngIf="step > 0" /></p>
    <p class="fs-24px">{{'header.doc'| translate}}</p>
  </div>
  <img src="assets/images/chevron-down.svg" alt="" width="100px" height="36px">
  <div class="flex-row step-status-inactive" [ngClass]="{'step-status':step >= 1   }">
    <p class="fs-16px" [ngClass]="{'step-status-check':step > 1   }">{{'header.step2'| translate}} <img alt=""
        src="../../../../assets/images/formCorrect.svg" class="TitleFormAlert-icon" *ngIf="step > 1" /></p>
    <p class="fs-24px">{{'header.baggage'| translate}}</p>
  </div>
  <img src="assets/images/chevron-down.svg" alt="" width="100px" height="36px">
  <div class="flex-row step-status-inactive" [ngClass]="{'step-status':step >= 2   }">
    <p class="fs-16px" [ngClass]="{'step-status-check':step > 2 }">{{'header.step3'| translate}} <img alt=""
        src="../../../../assets/images/formCorrect.svg" class="TitleFormAlert-icon" *ngIf="step > 2" /></p>
    <p class="fs-24px">{{'header.tag'| translate}}</p>
  </div>
</div>
